import React from "react"

import Intro from "../components/Intro"
import Team from "../components/Team"
import Locations from "../components/Locations"
import TherapyOffered from "../components/TherapyOffered"
import AreasOfSupport from "../components/AreasOfSupport"
import Fees from "../components/Fees"
import Faq from "../components/Faq"
import ReviewsDisplay from "../components/ReviewsDisplay"
import ContactUs from "../components/ContactUs"
import Navbar from "../components/Navbar"
import Hero from "../components/Hero"
import ScrollToTopButton from "../components/ScrollToTopButton"

export default function Home() {
  return (
    <div>
           <Navbar /> 
                 <Hero />
           
      <Intro />
      <Team />
      <Locations />
      <TherapyOffered />
      <AreasOfSupport />
      <Fees />
      <Faq />
      <ReviewsDisplay />
      <ContactUs />
      <ScrollToTopButton />
    </div>
  )
}
